import { useSelector } from "react-redux";
import { selectCustomerAttributeConstraints, setCustomerAttributeConstraints } from "../redux/shareSlice";
import { ReviewCustomersApi } from "../shared/api/ReviewCustomers.api";
import { store } from "../store/store";
import { CustomerAttributeConstraintType } from "../shared/enums";

export const useCustomerAttributeConstraint = () => {
  const customerAttributeConstraints = useSelector(selectCustomerAttributeConstraints);

  const loadCustomerAttributeConstraints = async () => {
    if (customerAttributeConstraints.length !== 0) {
      return;
    }

    var data = await ReviewCustomersApi.getCustomerAttributeConstraints();
    store.dispatch(setCustomerAttributeConstraints(data));
  };

  const getCustomerAttributeConstraintsByType = (type: CustomerAttributeConstraintType) => {
    return customerAttributeConstraints.filter((item) => item.type === type).map((item) => item.code);
  };

  return { customerAttributeConstraints, loadCustomerAttributeConstraints, getCustomerAttributeConstraintsByType };
};
